import AbsListItem from '../components/AbsListItem';

export default class ListItem extends AbsListItem{
    
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', it = {}){
        super(_name, _store, _actions, _router, _el, it);

        this.favApi = `${this.store.getState().config.apiDomain}/webcontents/favorites/spells/${it.id}`;
        this.detailPrefix = `spell_`;

        this.makeItem(it);
        this.addEvents();
    }

    makeItem(it = {}){
        let consume = [
            it.hpCost? 'HP '+it.hpCost :'',
            it.mpCost? 'MP '+it.mpCost :'',
            it.spellMaterialItemDisplay? it.spellMaterialItemDisplay :''
        ].filter( item => item!=='' ).join('<br>');
        consume = consume===''? '-': consume;

        this.itemEl = $(`
        <div class="tablerow" data-id="${it.id}">
            <div class="tablecell"><button class="btn-favorite${it.favorite?' is-active':''}" data-id="${it.id}">${it.favorite?'★':'☆'}</button></div>
            <div class="tablecell">
                <button class="btn-item">
                    <img class="thumb" src="${it.image}" onerror="this.src='${this.store.getState().defaultThumb}';">
                    <strong class="name" data-itemgrade="${it.gradeId}">${it.name}</strong>
                </button>
            </div>
            <div class="tablecell">${it.spellTypeName}</div>
            <div class="tablecell">${consume}</div>
            <div class="tablecell">${it.effectDescription}</div>
        </div>`);
        return this.itemEl;
    }

} // end of class